<template>
  <!-- Post-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <h2 class="text-center mb-3" v-html="$t('PostProgram.ProgramEndedTitle')"></h2>
      <p class="page-subheader" v-html="$t('PostProgram.ProgramEndedDesc')"></p>
      <p class="my-4"><a href='https://www.wkkellogg.com/where-to-buy' target='_blank' class='btn btn-link'><small v-html="$t('PostProgram.ExploreBtn')"></small></a></p>
    </div>
  </main>
</template>
<script>
export default {
  props: {
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
